// Contact Basic Form Handler
import { executeRecaptcha } from './recaptcha-handler.js';

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('contact_form_basic');

    console.log("formulario")
    if (!form) return;

    // Phone input validation - only allow numbers, spaces, dashes, parentheses and +
    const phoneInput = form.querySelector('#phone_basic');
    if (phoneInput) {
        phoneInput.addEventListener('input', function() {
            // Remove any character that is not a number, space, dash, parenthesis or +
            this.value = this.value.replace(/[^0-9+\s\-\(\)]/g, '');
        });
    }

    // Postal code validation - only allow numbers
    const postalCodeInput = form.querySelector('#postal_code');
    if (postalCodeInput) {
        postalCodeInput.addEventListener('input', function() {
            // Remove any character that is not a number
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    form.addEventListener('submit', function(event) {
        event.preventDefault();

        const feedback = document.querySelector('.js-contact-basic-feedback');
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.innerHTML;

        // Reset UI
        feedback.style.display = 'none';
        feedback.classList.remove('bg-green-100', 'text-green-800', 'bg-red-100', 'text-red-800');
        submitButton.disabled = true;
        submitButton.innerHTML = submitButton.getAttribute('data-sending-text') || 'Enviando...';

        // Execute reCAPTCHA v3 with reusable handler
        executeRecaptcha({
            form: form,
            tokenFieldId: 'g-recaptcha-response-basic',
            defaultAction: 'contact_form_basic',
            onSuccess: () => submitContactBasicForm(form, feedback, submitButton, originalButtonText),
            onError: () => {
                showContactBasicFeedback(feedback, 'Error al procesar el formulario. Por favor, intenta de nuevo.', 'error');
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
            }
        });
    });
});

function submitContactBasicForm(form, feedback, submitButton, originalButtonText) {
    // Get form data
    const formData = new FormData(form);
    const actionUrl = form.getAttribute('data-action');

    // Send request using Axios
    window.axios.post(actionUrl, formData)
            .then(function(response) {
                if (response.data.success == 0) {
                    showContactBasicFeedback(feedback, response.data.message, 'error');
                } else {
                    console.log("Succes form 1")
                    if (typeof aap === "function") {
                        console.log("AcuityAds pixel: enviando evento...", {
                            pixelKey: "7128893044111329273",
                            pg: 47831
                        });
                        aap({ pixelKey: "7128893044111329273", pg: 47831 });
                        console.log("AcuityAds pixel: evento enviado correctamente");
                        } else {
                        console.warn("AcuityAds pixel NO disponible: aap no es una función");
                        }
                    form.reset();
                    // Mostrar modal de confirmación
                    // Si la respuesta incluye un mensaje personalizado, usarlo
                    const customMessage = response.data.message || null;
                    showConfirmationModal(customMessage);
                }
            })
            .catch(function(error) {
                let errorMessage = 'Ha ocurrido un error. Por favor, inténtalo de nuevo.';

                if (error.response) {
                    if (error.response.status === 422 && error.response.data) {
                        const response = error.response.data;
                        if (response.errors) {
                            // Get the first validation error message
                            const firstError = Object.values(response.errors).flat()[0];
                            if (firstError) errorMessage = firstError;
                        } else if (response.message) {
                            errorMessage = response.message;
                        }
                    } else if (error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                }

                showContactBasicFeedback(feedback, errorMessage, 'error');
            })
            .finally(function() {
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
            });
}

function showContactBasicFeedback(feedbackElement, message, type) {
    const classes = type === 'success'
        ? ['bg-green-100', 'text-green-800', 'p-4', 'rounded-lg', 'mt-4']
        : ['bg-red-100', 'text-red-800', 'p-4', 'rounded-lg', 'mt-4'];

    feedbackElement.classList.remove('bg-green-100', 'text-green-800', 'bg-red-100', 'text-red-800');
    feedbackElement.classList.add(...classes);
    feedbackElement.innerHTML = message;
    feedbackElement.style.display = 'block';
    feedbackElement.style.opacity = '1';
}
